
import React, { useState } from "react";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  YAxis,
} from "recharts";
import GenericButton from "../../common/genericButton";
import InfoTopBar from "../../common/InfoTopBar/InfoTopBar";
import SendBTC from "../../Modals/SendBTC/SendBtc";
import Recieve from "../../Modals/RecievePopups/Recieve"
import PriceChart from "../PriceChart/PriceChart";
import styles from "./ActiveAsset.module.scss";
const data = [
  {
    name: "Page A",
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: "Page B",
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: "Page C",
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: "Page D",
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: "Page E",
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: "Page F",
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: "Page G",
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];
export default function ActiveAsset() {
  const [isOpensendBTC, setisOpensendBTC] = useState(false);
  const [isOpenReceiveBTC, setisOpenReceiveBTC] = useState(false);

  const toggleSend = () => {
    setisOpensendBTC(!isOpensendBTC);
  };
  const toggleReceive = () => {
    setisOpenReceiveBTC(!isOpenReceiveBTC);
  };
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.shortInfoWrapper}>
          <div className={styles.leftWrapper}>
            <img
              src={"/assets/bitcoin-btc-logo.svg"}
              width="35px"
              height="35px"
              alt="Picture of the author"
            />
            <div className={styles.chartWrapper}>
              <ResponsiveContainer width="100%" height={50}>
                <AreaChart width={"100%"} height={50} data={data}>
                  <defs>
                    <linearGradient id="colorUvv" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#00c053" stopOpacity={0.5} />
                      <stop offset="95%" stopColor="#00c053" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <Tooltip />
                  <Area
                    type="monotone"
                    dataKey="uv"
                    fillOpacity={1}
                    stroke="#00c053"
                    fill="url(#colorUvv)"
                  />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </div>
          <div className={styles.rightWrapper}>
            <div className={styles.coin}>BTC</div>
            <div className={styles.balance}>0.0819132 BTC</div>
            <div className={styles.balanceInUsd}>$651.49</div>
            <div className={styles.chartAssetChangeRow}>
              <img
                src={"/assets/polygon.svg"}
                width="10px"
                height="7px"
                alt="Picture of the author"
              />
              <div className={styles.changePositive}>+5.07%</div>
            </div>
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <GenericButton title="Send" icon="/assets/send.svg" onClick={toggleSend}/>
          <GenericButton title="Receive" icon="/assets/Path.svg" inline={true} onClick={toggleReceive} />
        </div>
      {/*<InfoTopBar />*/} 
        <PriceChart
          defaultCurrency={"USD"}
          walletData={[]}
          activeCoinIndex={0}
          fill={"#F89F36"}
        />
      </div>
      <SendBTC isOpen={isOpensendBTC} toggle={toggleSend} />
      <Recieve isOpen={isOpenReceiveBTC} toggle={toggleReceive} />
    </div>
  );
}
